import React from "react"
import { useMemo } from "react";

import classes from "./RotatingTrilingualHeadline.module.scss";

export default function RotatingTrilingualHeadline({
  index,
  className = "",
  transitionMs = 500,
}) {
  const items = useMemo(
    () => [
      { lang: "fa", dir: "rtl", text: "اینجا غذای خود را سفارش دهید" },
      { lang: "ar", dir: "rtl", text: "اطلب طعامك هنا" },
      { lang: "en", dir: "ltr", text: "ORDER YOUR FOOD HERE" },
    ],
    []
  );

  return (
    <div
      className={`${classes["headline-container"]} ${className}`}
      aria-label="Multilingual order headline"
    >
      {items.map((it, i) => {
        const isActive = i === index;

        return (
          <div
            key={it.lang}
            dir={it.dir}
            lang={it.lang}
            className={`${classes["headline-item"]} ${isActive ? classes["active"] : classes["inactive"]}`}
            style={{ transitionDuration: `${transitionMs}ms` }}
            aria-hidden={!isActive}
          >
            <h2>{it.text}</h2>
          </div>
        );
      })}
    </div>
  );
}